export const chainsList = {
  25: {
    name: "Cronos Mainnet Beta",
    symbol: "CRO",
    decimals: 18,
    rpc: ["https://evm-cronos.crypto.org/"],
    explorers: ["https://cronoscan.com/"],
  },
  56: {
    name: "BSC Mainnet",
    symbol: "BNB",
    decimals: 18,
    rpc: ["https://bsc-dataseed.binance.org"],
    explorers: ["https://bscscan.com/"],
  },
  137: {
    name: "Polygon Mainnet",
    symbol: "MATIC",
    decimals: 18,
    rpc: ["https://polygon-rpc.com/"],
    explorers: ["https://polygonscan.com/"],
  },
  43114: {
    name: "Avalanche Mainnet C-Chain",
    symbol: "AVAX",
    decimals: 18,
    rpc: ["https://api.avax.network/ext/bc/C/rpc"],
    explorers: ["https://snowtrace.io/"],
  },
};
